/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-03-07 11:52:29
 * @LastEditTime: 2022-04-24 14:44:53
 * @FilePath: \insurforce-backstage-platform-side\src\views\system\authorityManage\request.js
 */
import request from '@/utils/request';
/**获取列表数据 */
export function permissionsList(data) {
  return request.post('admin/permissions/list', data);
}
export function permissionsFieldList(data) {
  return request.post('admin/permissions/field/list', data);
}
export function configList(data, type) {
  console.log(type);
  let url = 'admin/customer/config';
  let data2 = data;
  if (type == 'role') {
    data2 = {
      roleId: data.customerId
    };
    url = 'admin/role/config';
  } else if (type == 'customerRole') {
    data2 = {
      roleId: data.customerId.split(',')[0],
      customerId: data.customerId.split(',')[1]
    };
    url = 'admin/customer/role/config';
  }
  console.log(data2);
  return request.post(url, data2);
}
/**删除 */
export function permissionsDelete(data) {
  return request.post('admin/permissions/delete', data);
}
export function fieldDelete(data) {
  return request.post('admin/permissions/field/delete', data);
}
/**新增 */
export function addPermissions(data) {
  return request.post('admin/permissions/store', data);
}
export function addField(data) {
  return request.post('admin/permissions/field/store', data);
}
/**编辑 */
export function editField(data) {
  data.permissionsFieldId = data.id;
  return request.post('admin/permissions/field/edit', data);
}
export function editPermissions(data) {
  return request.post('admin/permissions/edit', data);
}
/**详情 */
export function permissionsDetail(data) {
  return request.post('admin/permissions/detail', data);
}
/**查询配置 */
export function configStore(data, type) {
  let url = 'admin/customer/configStore';
  let data2 = data;
  if (type == 'role') {
    data2 = {
      roleId: data.customerId,
      permissionsData: data.permissionsData,
      desensitize: data.desensitize
    };
    url = 'admin/role/configStore';
  } else if (type == 'customerRole') {
    data2 = {
      roleId: data.customerId.split(',')[0],
      customerId: data.customerId.split(',')[1],
      permissionsData: data.permissionsData,
      desensitize: data.desensitize
    };
    url = 'admin/customer/role/configStore';
  }
  return request.post(url, data2);
}
// 修改状态
export function permissionsStatus(data) {
  return request.post('admin/permissions/status', data);
}
// 客户角色权限脱敏限制
export function getDesensitizePermission(data) {
  return request.post('admin/customer/role/getDesensitizePermission', data);
}